<template>
  <div class="procedureSub">
    <div class="flowChart ft14">
      <dl class="active">
        <ul>
          <li>
            <span></span>
          </li>
          <li>
            <div>
              <span></span>
            </div>
            <p>填写信息</p>
          </li>
          <li>
            <span></span>
          </li>
        </ul>
      </dl>
      <dl>
            <ul>
              <li>
                <span></span>
              </li>
              <li>
                <div>
                  <span></span>
                </div>
                <p>信息审核</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
      <dl>
        <ul>
          <li>
            <span></span>
          </li>
          <li>
            <div>
              <span></span>
            </div>
            <p>支付费用</p>
          </li>
          <li>
            <span></span>
          </li>
        </ul>
      </dl>
      <dl>
        <ul>
          <li>
            <span></span>
          </li>
          <li>
            <div>
              <span></span>
            </div>
            <p>预约取证</p>
          </li>
          <li>
            <span></span>
          </li>
        </ul>
      </dl>
    </div>
    <div class="procedureTab">
      <div class="message active">
        <div class="messageLeft fl">
          <h5>
            <img src="../../../../../assets/images/procedure/information_icon.png">申请信息
          </h5>
          <div class="messageCon">
            <el-form>
              <el-form-item label="申请公证名称：">{{returnList.name}}</el-form-item>
              <el-form-item label="包含文件数量：">{{returnList.fileAmount}}</el-form-item>
              <el-form-item label="文件总大小：">{{returnList.fileSize}}</el-form-item>
              <el-form-item label="公证处：">{{returnList.office}}</el-form-item>
              <el-form-item label="公证处地址：">{{returnList.address}}</el-form-item>
              <el-form-item label="公证书份数：" class="numFile">
                <el-input v-model="num" placeholder="1" class="fileNum" @blur="fileNumFn"></el-input>
                <p v-show="fileNum">*请输入有效公证书份数(1-100之间的整数)</p>
              </el-form-item>
              <el-form-item label="公证书领取：">
                <span v-if="returnList.receiptorType==1">本人领取</span>
                <span v-if="returnList.receiptorType==2">其他人自然领取</span>
                <span v-if="returnList.receiptorType==3">账号使用者领取</span>
              </el-form-item>
              <el-form-item label="备注：">{{returnList.remarks}}</el-form-item>
            </el-form>
          </div>
        </div>
        <div class="messageLeft fr" v-if="type==1">
          <h5>
            <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
          </h5>
          <div class="messageCon" v-if="returnList.receiptorType=='2'">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
              <el-form-item label="身份证：">{{returnList.userIdCard}}</el-form-item>
              <el-form-item label="户口所在地：" prop="registeredHome">
                <el-input v-model="ruleForm.registeredHome" placeholder="输入户口所在地" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="现居住地址：" prop="currentHome">
                <el-input v-model="ruleForm.currentHome" placeholder="输入现居住地址" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="领取人姓名：" prop="proxyName">
                <el-input v-model="ruleForm.proxyName" placeholder="请输入领取人姓名"></el-input>
              </el-form-item>
              <el-form-item label="领取人身份证：" prop="proxyCard">
                <el-input v-model="ruleForm.proxyCard" placeholder="请输入正确的身份证号码"></el-input>
              </el-form-item>
              <el-form-item label="领取人手机号：" prop="photo">
                <el-input v-model="ruleForm.photo" placeholder="输入11位手机号"></el-input>
              </el-form-item>
              <el-form-item label="领取人邮箱：" prop="mail">
                <el-input v-model="ruleForm.mail" placeholder="输入领取人邮箱"></el-input>
              </el-form-item>
              <el-form-item class="subBox">
                <el-button type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="messageCon" v-if="returnList.receiptorType=='1'">
            <el-form :model="ruleForms" :rules="ruless" ref="ruleForms" class="demo-ruleForm">
              <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
              <el-form-item label="身份证：">{{returnList.userIdCard}}</el-form-item>
              <el-form-item label="户口所在地：" prop="registeredHome">
                <el-input v-model="ruleForms.registeredHome" placeholder="输入户口所在地" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="现居住地址：" prop="currentHome">
                <el-input v-model="ruleForms.currentHome" placeholder="输入现居住地址" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="领取人姓名：" prop="proxyName">
                <span>{{returnList.applier}}</span>
              </el-form-item>
              <el-form-item label="领取人身份证：" prop="proxyCard">
                <span>{{returnList.userIdCard}}</span>
              </el-form-item>
              <el-form-item label="领取人手机号：" prop="photo">
                <el-input v-model="ruleForms.photo" placeholder="输入11位手机号"></el-input>
              </el-form-item>
              <el-form-item label="领取人邮箱：" prop="mail">
                <el-input v-model="ruleForms.mail" placeholder="输入领取人邮箱"></el-input>
              </el-form-item>
              <el-form-item class="subBox">
                <el-button type="primary" @click="submitForms('ruleForms')">提交申请</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="messageLeft fr" v-if="type==2">
          <h5>
            <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
          </h5>
          <div class="messageCon" v-if="returnList.receiptorType=='2'">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
              <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
              <el-form-item label="注册地址：" prop="registeredHome">
                <el-input v-model="ruleForm.registeredHome" placeholder="输入注册地址" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="公司所在地：" prop="currentHome">
                <el-input v-model="ruleForm.currentHome" placeholder="输入公司所在地" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="领取人姓名：" prop="proxyName">
                <el-input v-model="ruleForm.proxyName" placeholder="请输入领取人姓名"></el-input>
              </el-form-item>
              <el-form-item label="领取人身份证：" prop="proxyCard">
                <el-input v-model="ruleForm.proxyCard" placeholder="请输入正确的身份证号码"></el-input>
              </el-form-item>
              <el-form-item label="领取人手机号：" prop="photo">
                <el-input v-model="ruleForm.photo" placeholder="输入11位手机号"></el-input>
              </el-form-item>
              <el-form-item label="领取人邮箱：" prop="mail">
                <el-input v-model="ruleForm.mail" placeholder="输入领取人邮箱"></el-input>
              </el-form-item>
              <el-form-item class="subBox">
                <el-button type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="messageCon" v-if="returnList.receiptorType=='1'">
            <el-form :model="ruleForms" :rules="ruless" ref="ruleForms" class="demo-ruleForm">
              <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
              <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
              <el-form-item label="注册地址：" prop="registeredHome">
                <el-input v-model="ruleForms.registeredHome" placeholder="输入注册地址" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="公司所在地：" prop="currentHome">
                <el-input v-model="ruleForms.currentHome" placeholder="输入公司所在地" class="fileNum"></el-input>
              </el-form-item>
              <el-form-item label="领取人姓名：" prop="proxyName">
                <span>{{returnList.legalPersonName}}</span>
              </el-form-item>
              <el-form-item label="领取人身份证：" prop="proxyCard">
                <span>{{returnList.legalPersonIdcardNumber}}</span>
              </el-form-item>
              <el-form-item label="领取人手机号：" prop="photo">
                <el-input v-model="ruleForms.photo" placeholder="输入11位手机号"></el-input>
              </el-form-item>
              <el-form-item label="领取人邮箱：" prop="mail">
                <el-input v-model="ruleForms.mail" placeholder="输入领取人邮箱"></el-input>
              </el-form-item>
              <el-form-item class="subBox">
                <el-button type="primary" @click="submitForms('ruleForms')">提交申请</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="message">
        <div class="messageStatus">
          <h5>
            <img src="../../../../../assets/images/procedure/waiting_icon.png">等待制证
          </h5>
          <div class="messageCon">
            <img src="../../../../../assets/images/service/submitted_icon.png">
            <p>您的申请信息已提交公证处审核，预计在1个工作日内会将审核结果通过短信发送到您的手机上，请注意查收。在此期间如您有疑问可联系客服电话：010-86208510</p>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :visible="successFulBox"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog">
        <div class="successFulBox">提交申请失败</div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import {mapState, mapGetters} from "vuex";
export default {
  data() {
    return {
      type: 1,
      id: "",
      fileNum: false,
      successFulBox: false,
      returnList: {},
      num: "",
      ruleForm: {
        mail: "",
        photo: "",
        registeredHome: "",
        currentHome: "",
        proxyName: "",
        proxyCard: ""
      },
      ruleForms: {
        mail: "",
        photo: "",
        registeredHome: "",
        currentHome: "",
        proxyName: "",
        proxyCard: ""
      },
      rules: {
        mail: [
          { required: true, message: "*请输入邮箱", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "*邮箱格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        photo: [
          { required: true, message: "*请输入手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "*手机号格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        registeredHome: [
          { required: true, message: "*请输注册地址", trigger: "blur" },
          { max: 50, message: "*最多50个字符", trigger: "blur" }
        ],
        currentHome: [
          { required: true, message: "*请输入公司所在地", trigger: "blur" },
          { max: 50, message: "*最多50个字符", trigger: "blur" }
        ],
        proxyName: [
          { required: true, message: "*请输入领取人姓名", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]+$/,
            message: "*您输入的格式不对",
            trigger: "blur"
          }
        ],
        proxyCard: [
          { required: true, message: "*请输入领取人身份证号", trigger: "blur" },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "*您输入的格式不对",
            trigger: "blur"
          }
        ]
      },
      ruless: {
        mail: [
          { required: true, message: "*请输入邮箱", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "*邮箱格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        photo: [
          { required: true, message: "*请输入手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "*手机号格式错误，请重新输入",
            trigger: "blur"
          }
        ],
        registeredHome: [
          { required: true, message: "*请输入户口所在地", trigger: "blur" },
          { max: 50, message: "*最多50个字符", trigger: "blur" }
        ],
        currentHome: [
          { required: true, message: "*请输入公司所在地", trigger: "blur" },
          { max: 50, message: "*最多50个字符", trigger: "blur" }
        ]
      }
    };
  },
  computed:{
      ...mapState(['currentInfo','userInfo']),
  },
  mounted() {
    this.returnList = JSON.parse(sessionStorage.getItem("procedure"));
    this.money = this.returnList.cost;
    (this.notaryId = this.returnList.notaryId),
      (this.id = this.$route.query.id);
  },
  methods: {
    fileNumFn() {
      if (this.num == "") {
        this.fileNum = true;
      }
      if (/^([1-9][0-9]{0,1}|100)$/.test(this.num) == false) {
        this.fileNum = true;
      }
      setTimeout(() => {
        this.fileNum = false;
      }, 1000);
    },
    messageFn() {
      var params = {
        notaryServiceId: this.id
      };
      BaseApi.createRpcToken("/Judiciary/getNotarizationInfo", params)
        .then(
          data => {
            console.log(data);
            this.returnList = data.datas;
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    submitForm(formName) {
      if (this.type == 2) {
        this.ruleForm.registeredHome = this.ruleForm.currentHome;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.num == "") {
            this.fileNum = true;
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: "正在提交"
          });
          this.fileNum = false;
          var params = {
            userDomicile: this.ruleForm.registeredHome,
            userAddress: this.ruleForm.currentHome,
            proxyName: this.ruleForm.proxyName,
            proxyCard: this.ruleForm.proxyCard,
            proxyMobile: this.ruleForm.photo,
            proxyMail: this.ruleForm.mail,
            name: this.returnList.name,
            notarial: this.returnList.office,
            id: this.returnList.notaryId,
            pageNum: this.num
          };
          if (this.returnList.receiptorType == 1) {
            params.proxyCard = this.returnList.userIdCard;
            params.proxyName = this.returnList.applier;
          }
          BaseApi.createRpcToken("/Judiciary/saveRecipients", params)
            .then(
              data => {
                if (data.datas.success == true) {
                  loading.close();
                  $(".flowChart dl")
                    .eq(1)
                    .addClass("active");
                  $(".message")
                    .siblings()
                    .removeClass("active");
                  $(".message")
                    .eq(1)
                    .addClass("active");
                } else {
                  loading.close();
                  this.successFulBox = true;
                  setTimeout(() => {
                    this.successFulBox = false;
                  }, 2000);
                }
              },
              data => {
                loading.close();
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          console.log("error submit!!");
          if (this.num != "") {
            this.fileNum = false;
            return;
          } else {
            this.fileNum = true;
          }
          return false;
        }
      });
    },
    submitForms(formName) {
      if (this.type == 2) {
        this.ruleForms.registeredHome = this.ruleForms.currentHome;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.num == "") {
            this.fileNum = true;
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: "正在提交"
          });
          // if (this.fileNum == true) {
          //   return;
          // }
          this.fileNum = false;
          var params = {
            userDomicile: this.ruleForms.registeredHome,
            userAddress: this.ruleForms.currentHome,
            proxyName: this.ruleForms.proxyName,
            proxyCard: this.ruleForms.proxyCard,
            proxyMobile: this.ruleForms.photo,
            proxyMail: this.ruleForms.mail,
            name: this.returnList.name,
            notarial: this.returnList.office,
            id: this.returnList.notaryId,
            pageNum: this.num
          };
          if (this.returnList.receiptorType == 1) {
            params.proxyCard = this.returnList.userIdCard;
            params.proxyName = this.returnList.applier;
          }
          BaseApi.createRpcToken("/Judiciary/saveRecipients", params, "post")
            .then(
              data => {
                if (data.datas.success == true) {
                  loading.close();
                  $(".flowChart dl")
                    .eq(1)
                    .addClass("active");
                  $(".message")
                    .siblings()
                    .removeClass("active");
                  $(".message")
                    .eq(1)
                    .addClass("active");
                } else {
                  loading.close();
                  this.successFulBox = true;
                  setTimeout(() => {
                    this.successFulBox = false;
                  }, 2000);
                }
              },
              data => {
                loading.close();
                console.log(data);
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          console.log("error submit!!");
          if (this.num != "") {
            this.fileNum = false;
            return;
          } else {
            this.fileNum = true;
          }
          return false;
        }
      });
    },
    closeDialog(data) {
      this.successFulBox = data;
    }
  },
  components: {
    BaseApi,
    Dialog
  },
  created() {
     BaseApi.createRpcToken("/user/v2/getUserInfo")
      .then(data => {
          let userArr=[...[data.datas.person],...data.datas.enterpriseList];
          let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)[0];
           this.type=curInfo.realNameType
      })
      .catch(function(e) {
        errorLog(e);
      });
    // this.type = JSON.parse(sessionStorage.getItem("userInfo")).realNameType;
  },
   watch:{
    "currentInfo"(data){
      this.$router.replace("/personal/serviceHome")
    }
  }
};
</script>
<style lang="scss">
.procedureSub {
  margin-top: 20px;
  width: 100%;
  .flowChart {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 43px;
    overflow: hidden;
    height: 50px;
    li {
      float: left;
      height: 20px;
    }
    li:nth-child(2n-1) {
      position: relative;
      width: calc((100% - 112px) / 8);
      span {
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -1px;
        display: inline-block;
        width: 100%;
        height: 2px;
        background: #fbeceb;
        border-radius: 3px;
      }
    }
    dl.active {
      li:nth-child(2n-1) {
        span {
          background: #e98880;
        }
      }
      li:nth-child(2) {
        cursor: pointer;
        div {
          width: 20px;
          height: 20px;
          background: #fbeceb;
          border: 1px solid #e88078;
          border-radius: 50%;
          padding: 4px;
          box-sizing: border-box;
          margin: 0 4px;
        }
        span {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #e88078;
        }
      }
    }
    li:nth-child(2n) {
      position: relative;
      div {
        width: 20px;
        height: 20px;
        background: #fbeceb;
        border: 1px solid #fbeceb;
        border-radius: 50%;
        padding: 2px;
        box-sizing: border-box;
        margin: 0 4px;
      }
      p {
        position: absolute;
        width: 84px;
        color: #505050;
        top: 31px;
        left: -26px;
        text-align: center;
      }
    }
    .select {
      span {
        background: #e98880 !important;
      }
    }
  }
  .procedureTab {
    width: 100%;
    display: table;
    .putIn {
      text-align: center;
      span {
        display: inline-block;
        border: 1px solid #e29999;
        width: 140px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 12px;
        color: #e29999;
      }
    }
    .message {
      display: none;
      h5 {
        background: #f7f7f7;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        padding-left: 20px;
        color: #646464;
        font-weight: normal;
        border-bottom: 1px solid #e4e8eb;
        img {
          vertical-align: middle;
          margin-right: 4px;
        }
      }
      .messageLeft {
        width: calc(96% / 2);
        display: table;
        border: 1px solid #e4e8eb;
        margin-bottom: 20px;
        .messageCon {
          width: 100%;
          box-sizing: border-box;
          height: 377px;
          background: #fafafa;
          position: relative;
          .el-form {
            padding-left: 43px;
            padding-top: 25px;
            .el-form-item.is-required:not(.is-no-asterisk)
              > .el-form-item__label:before {
              content: "";
            }
            .el-form-item {
              font-size: 12px;
              color: #646464;
              margin-bottom: 20px;
              .el-form-item__label {
                line-height: 24px;
                padding: 0;
                width: 150px;
                text-align: left;
              }
              .el-form-item__content {
                line-height: 24px;
              }
            }
            .el-form-item__content {
              position: relative;
              .el-input {
                width: 296px;
                .el-input__inner {
                  padding-left: 10px;
                  height: 20px;
                  line-height: 20px;
                  border-radius: 0;
                }
              }
              .el-form-item__error {
                left: 152px;
              }
            }
            .subBox {
              position: absolute;
              bottom: -30%;
              left: -100px;
              .el-button {
                width: 140px;
                line-height: 36px;
                padding: 0;
                background-color: #fff;
                font-size: 12px;
                color: #e29999;
                border-color: #e29999;
              }
            }
            .el-button:hover {
              color: #fff;
              background-color: #a5303d;
              border-color: #a5303d;
            }
          }
          .numFile {
            position: relative;
            p {
              position: absolute;
              left: 150px;
              color: #f56c6c;
              font-size: 12px;
            }
          }
          .fileNum {
            background: #f0f0f0;
            height: 20px;
            width: 60px;
            border-radius: 2px;
            font-size: 12px;
            color: #646464;
            position: relative;
            .el-input__inner {
              padding: 0;
              height: 20px;
              line-height: 20px;
              padding-left: 10px;
              box-sizing: border-box;
            }
          }
        }
      }
      .messageLeft:nth-child(1) {
        margin-right: 3%;
      }
      .messageStatus {
        width: 100%;
        border: 1px solid #e4e8eb;
        .messageCon {
          display: flex;
          width: 100%;
          box-sizing: border-box;
          height: 240px;
          background: #fafafa;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          font-size: 14px;
          color: #646464;
          img {
            margin-bottom: 10px;
          }
          p {
            width: 60%;
            text-align: center;
          }
        }
      }
      .moneyBox {
        border: 1px solid #e4e8eb;
        .messageCon {
          background: #fafafa;
          width: 100%;
          height: 161px;
          padding: 20px 11px;
          box-sizing: border-box;
          table {
            table-layout: auto;
            thead {
              width: 100%;
            }
            th:nth-child(1),
            td:nth-child(1) {
              width: "24.4%";
            }
            th:nth-child(2),
            td:nth-child(2) {
              width: "16.2%";
            }
            th:nth-child(3),
            td:nth-child(3) {
              width: "19.8%";
            }
            th:nth-child(4),
            td:nth-child(4) {
              width: "14.4%";
            }
            th:nth-child(5),
            td:nth-child(5) {
              width: "16.2%";
            }
            th:nth-child(6),
            td:nth-child(6) {
              width: "9";
            }
            th {
              background: #f9f9f9;
            }
            td {
              background-color: #fff;
            }
            th,
            td {
              padding: 0;
              vertical-align: middle;
              width: 100px;
              overflow: hidden;
              .cell {
                height: 30px;
                line-height: 30px;
                text-align: center;
              }
            }
          }
          p {
            text-align: right;
            font-size: 12px;
            color: #969696;
            margin-top: 28px;
            span {
              font-size: 24px;
              color: #e88078;
            }
          }
        }
      }
    }
    .active {
      display: block;
    }
  }
  .successFulBox {
    height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #646464;
  }
}
</style>
